const DEFAULT_EVENT_NAME = 'hds-algolia-search:open';
const BUTTON_SELECTOR = '[data-hds-search-open-event]';

function resolveOpenEventName(button) {
  const fromButton = button?.dataset.hdsSearchOpenEvent?.trim();
  if (fromButton) return fromButton;

  const fromDocument = document.documentElement.dataset.hdsSearchOpenEvent?.trim();
  if (fromDocument) return fromDocument;

  return DEFAULT_EVENT_NAME;
}

function isSearchShortcut(event) {
  return (
    event.key.toLowerCase() === 'k' &&
    (event.metaKey || event.ctrlKey) &&
    !event.altKey &&
    !event.shiftKey
  );
}

function shouldIgnoreSearchShortcut(event) {
  const target = event.target;
  if (!(target instanceof Element)) return false;

  if (target instanceof HTMLElement && target.isContentEditable) return true;
  if (target.closest('[data-hds-algolia-search]')) return false;

  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}

/**
 * Header zoekknop in event-modus: opent externe zoek-UI (bv. Algolia modal).
 * Dispatch op document zodat app-listeners op document het event ontvangen.
 */
function dispatchOpenSearchEvent(eventName, source) {
  document.dispatchEvent(
    new CustomEvent(eventName, {
      bubbles: true,
      detail: { source },
    }),
  );
}

function openSearchFromButton(button) {
  dispatchOpenSearchEvent(resolveOpenEventName(button), 'theme-search-button');
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest(BUTTON_SELECTOR);
    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();
    event.stopPropagation();
    openSearchFromButton(button);
  },
  { capture: true },
);

document.addEventListener(
  'keydown',
  (event) => {
    if (!isSearchShortcut(event)) return;
    if (shouldIgnoreSearchShortcut(event)) return;

    const eventName = resolveOpenEventName();
    event.preventDefault();
    event.stopImmediatePropagation();
    dispatchOpenSearchEvent(eventName, 'theme-keyboard-shortcut');
  },
  { capture: true },
);

export {};
